import { render, staticRenderFns } from "./Salon_Menu_Sub_Category.vue?vue&type=template&id=3074d086&"
import script from "./Salon_Menu_Sub_Category.vue?vue&type=script&lang=js&"
export * from "./Salon_Menu_Sub_Category.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports